import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'Home', id: 'hero' },
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'Why IronClad', id: 'benefits' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled
            ? 'bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/5'
            : 'bg-transparent'
        }`}
      >
        <div className="px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex items-center cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <img
                src="https://static.readdy.ai/image/ad76438f27b7c76a25e10aafd906f29a/1f866004502f08d41232135bfc42dc55.png"
                alt="Elite Legal Partners"
                className="h-14 w-auto"
              />
            </div>

            {/* Desktop links */}
            <div className="hidden md:flex items-center gap-8">
              {navLinks.map(link => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="text-xs font-medium text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer tracking-widest uppercase"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {link.label}
                </button>
              ))}
              <button
                onClick={() => scrollTo('consultation')}
                className="px-6 py-2.5 bg-[#D4AF37] text-black text-xs font-bold rounded-md hover:bg-[#e8c547] transition-all duration-300 whitespace-nowrap cursor-pointer tracking-widest uppercase"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Book Consultation
              </button>
            </div>

            {/* Mobile hamburger */}
            <button
              className="md:hidden text-white cursor-pointer w-10 h-10 flex items-center justify-center"
              onClick={() => setMobileOpen(v => !v)}
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`} />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 bg-[#0a0a0a] flex flex-col items-center justify-center gap-8 md:hidden">
          {navLinks.map(link => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="text-2xl font-light text-white hover:text-[#D4AF37] transition-colors cursor-pointer tracking-wider"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('consultation')}
            className="px-10 py-3 bg-[#D4AF37] text-black text-sm font-bold rounded-md cursor-pointer tracking-widest uppercase mt-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Book Consultation
          </button>
        </div>
      )}
    </>
  );
}
